import { FlowContext } from 'src/lib/flow';
import { FlowPage } from 'src/lib/flow/FlowPage';
import { FlowQuestion } from 'src/lib/flow/FlowQuestion';
import { sellerGlobalPagePath } from 'src/routes/pathBuilders';

export function isEnabled({ answers }: FlowContext) {
  return answers['seller.listing_agreement_status'] === 'signed';
}

const listingAgentPage: FlowPage = {
  slug: () => 'listing-agent-info',
  title: () => 'Your agent will have to request an offer for you',
  subtitle: () =>
    "Your agent will have to request an offer on your behalf. Don't worry, it’s easy.",
  nextText: () => 'Email my agent',
  autoAdvance: () => false,
  hideProgress: () => true,
  questions: (): FlowQuestion[] => [
    {
      key: 'seller.listing_agent.full_name',
      label: 'Agent full name',
      type: 'single_line',
      placeholder: 'Enter their first and last name',
    },
    {
      key: 'seller.listing_agent.email',
      label: 'Agent email',
      type: 'email',
      placeholder: 'agent@example.com',
    },
  ],
  isEnabled,
  exitPath: ({ inputContext: { sellerInputUUID } }: FlowContext) => {
    return sellerGlobalPagePath({ token: sellerInputUUID, page: 'complete-listing-agent-request' });
  },
};

export default listingAgentPage;
